import { useEffect, useMemo, useState } from "react";
import { useNotificationContext } from "contexts/NotificationContext";
import { useParams } from "react-router-dom";
import { IFleet } from "models/fleet";
import { fetchFleetByIdApi } from "api/fleet";
import { ERole } from "models/account";
import { jwtDecode } from "jwt-decode";

export default function useFleetDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [data, setData] = useState<{ loading: boolean; data?: IFleet }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [id]);

  const role: ERole = useMemo(() => {
    const payload: any = jwtDecode(localStorage.getItem("token")!);
    return payload.role;
  }, []);

  const fetchData = async () => {
    setData({ loading: true });
    const { data, error } = await fetchFleetByIdApi(id);
    if (data?.data) {
      setData({ loading: false, data: data.data });
    } else showError(error!.message);
  };

  return {
    role,
    data,
  };
}
